import { useState } from 'react';
import { Row, Col, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { PlusOutlined } from '@ant-design/icons';
import { ProjectsDto, ProjectDto } from '@/core/http.projects';
import { Project } from './Project';
import { ProjectsListNoProjects } from './ProjectsListNoProjects';
import { ProjectModal } from './ProjectModal';
import classes from './ProjectsList.module.scss';

interface ProjectsListProps {
  projectsListData: ProjectsDto;
}

export const ProjectList = ({ projectsListData }: ProjectsListProps) => {
  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editedProject, setEditedProject] = useState<ProjectDto | null>(null);

  const createProject = () => setIsModalOpen(true);
  const handleClickRename = (project: ProjectDto) => {
    setEditedProject(project);
    setIsModalOpen(true);
  };

  return (
    <>
      <Button size="large" icon={<PlusOutlined />} onClick={createProject} type="primary">
        {t('projects.actions.addProject')}
      </Button>
      {projectsListData.items.length ? (
        <Row>
          <Col xs={24} md={20} xl={16}>
            <div className={classes.projectsList}>
              {projectsListData.items.map((project) => (
                <Project
                  key={project.id}
                  onClickMenuRename={() => handleClickRename(project)}
                  projectData={project}
                />
              ))}
            </div>
          </Col>
        </Row>
      ) : (
        <ProjectsListNoProjects />
      )}
      <ProjectModal
        isModalOpen={isModalOpen}
        setIsModalOpen={(value: boolean) => setIsModalOpen(value)}
        editedProject={editedProject}
        projectsListData={projectsListData}
        stopEdit={() => setEditedProject(null)}
      />
    </>
  );
};
